module.exports = __webpack_public_path__ + "static/media/innerLogo.3ce101ab.png";